import Banner from "../../models/common/Banner";
import gartner_banner from "../../assets/img/partnerPortal/welcomePage/gartner_banner.png";
import perform_banner from "../../assets/img/partnerPortal/welcomePage/perform_banner.jpg";

// BANNERS
const banner0: Banner = new Banner(
  "https://www.dynatrace.com/gartner-magic-quadrant-for-observability-platforms/?utm_med[…]race&utm_campaign=partner&utm_content=portal&utm_term=q2fy25",
  "_parent",
  "100%",
  gartner_banner
);
const banner1: Banner = new Banner(
  "https://partners.dynatrace.com/#/page/perform-2025-on-demand",
  "_parent",
  "100%",
  perform_banner
);
// const banner2: Banner = new Banner("https://www.dynatrace.com/innovate/?utm_medium=partner&utm_source=dynatrace&utm_campaign=innovate&utm_content=partner-portal&utm_term=25", "_parent", "100%",custom);
export const ALL_THE_BANNERS: Array<Banner> = new Array<Banner>(
  banner0,
  banner1
);
